import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatMenuModule} from '@angular/material/menu';
import {BestaetigungsFormComponent} from './bestaetigungs-form/bestaetigungs-form.component';
import {MatDialogModule} from '@angular/material/dialog';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {ResetPasswortFormComponent} from './resetPasswort-form/resetPasswort-form.component';
import {NewPasswortFormComponent} from './newPasswort-form/newPasswort-form.component';
import {InformationFormComponent} from "./information-form/information-form.component";
import {MatOptionModule} from '@angular/material/core';
import {MatSelectModule} from '@angular/material/select';
import {MatTooltipModule} from '@angular/material/tooltip';
import {TooltipModule} from 'ngx-bootstrap/tooltip';


@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatListModule,
    MatSidenavModule,
    RouterModule,
    TranslateModule,
    MatMenuModule,
    MatDialogModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatSelectModule,
    MatTooltipModule,
    TooltipModule,
  ],
    declarations: [NavBarComponent, BestaetigungsFormComponent, ResetPasswortFormComponent, NewPasswortFormComponent, InformationFormComponent],
    exports: [NavBarComponent, BestaetigungsFormComponent, ResetPasswortFormComponent, NewPasswortFormComponent, InformationFormComponent],
})
export class AppUiModule {}
